import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-card-capital-play',
    templateUrl: './card-capital-play.component.html',
    styleUrl: './card-capital-play.component.scss',
    standalone: false
})
export class CardCapitalPlayComponent {
  @Output() emitBeneficio = new EventEmitter<any>();

  goToBeneficio(){
    this.emitBeneficio.emit();
  }

}
